const PlayerHeroData = [
  {
    name: 'Luka Dončić',
    description:
      'Star player for the Dallas Mavericks known for his playmaking skills.',
    image: '/Luka Doncic.webp',
  },
  {
    name: 'Kevin Durant',
    description:
      'NBA champion and scoring legend currently with the Phoenix Suns.',
    image: '/kevin durant.webp',
  },
  {
    name: 'Jaylen Brown',
    description:
      'Boston Celtics star known for his athleticism and two-way play.',
    image: '/Jaylen Brown.webp',
  },
];

export default PlayerHeroData;
